import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';
import { SHARED_TYPOGRAPHY } from '../../../theme';

/**
 * ActivityTable Component
 *
 * Displays a table of recent activity with template names, execution times, and status
 */
const ActivityTable = ({ activities, maxRows = 5 }) => {
  if (!activities || activities.length === 0) {
    return (
      <Typography variant="body1" sx={SHARED_TYPOGRAPHY.bodySecondary}>
        No activity data available
      </Typography>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Template</TableCell>
            <TableCell align="right">Last Execution</TableCell>
            <TableCell align="center">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {activities.slice(0, maxRows).map(activity => (
            <TableRow key={activity.execution_id}>
              <TableCell>
                <Typography variant="body1" sx={SHARED_TYPOGRAPHY.bodyBold}>
                  {activity.template_name}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography
                  variant="body1"
                  sx={SHARED_TYPOGRAPHY.bodySecondary}
                >
                  {new Date(activity.last_execution).toLocaleString()}
                </Typography>
              </TableCell>
              <TableCell align="center">
                <Chip
                  label={activity.status}
                  color={activity.status === 'success' ? 'success' : 'error'}
                  size="medium"
                  icon={
                    activity.status === 'success' ? (
                      <CheckCircleIcon />
                    ) : (
                      <WarningIcon />
                    )
                  }
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ActivityTable;
